module.exports = __webpack_public_path__ + "static/assets/ad2841e0f0228e47e911a5b571480f7c.svg";